// extracted by mini-css-extract-plugin
module.exports = {"usersTable":"Dashboard_usersTable__Ngmwx"};